import React from "react";
import { Box, Button, Typography, Grid, TextField } from "@mui/material";

export default function PasoReferencias({ data, update, next, back }) {

  const referencias = data.referencias || [];

  const add = () => {
    if (referencias.length >= 2) return;
    update({
      referencias: [
        ...referencias,
        { nombre: "", telefono: "", parentesco: "" }
      ]
    });
  };

  const change = (i, field, value) => {
    const copia = [...referencias];
    copia[i][field] = value;
    update({ referencias: copia });
  };

  const eliminar = (i) => {
    const copia = [...referencias];
    copia.splice(i, 1);
    update({ referencias: copia });
  };

  return (
    <Box>
      <Typography variant="h6" fontWeight={600} mb={3}>
        Referencias
      </Typography>

      {referencias.map((r, i) => (
        <Grid container spacing={2} key={i} mb={2}>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Nombres y apellidos"
              fullWidth
              value={r.nombre}
              onChange={(e) => change(i, "nombre", e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <TextField
              type="number"
              label="Número de celular"
              fullWidth
              value={r.telefono}
              onChange={(e) => change(i, "telefono", e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              label="Parentesco"
              fullWidth
              value={r.parentesco}
              onChange={(e) => change(i, "parentesco", e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={1} display="flex" alignItems="center">
            <Button
              color="error"
              onClick={() => eliminar(i)}
              sx={{ minWidth: 0 }}
            >
              X
            </Button>
          </Grid>
        </Grid>
      ))}

      {/* BOTÓN AGREGAR REFERENCIA */}
      <Button
        variant="outlined"
        onClick={add}
        disabled={referencias.length >= 2}
        sx={{
          mb: 3,
          opacity: referencias.length >= 2 ? 0.5 : 1,
          cursor: referencias.length >= 2 ? "not-allowed" : "pointer",
          borderRadius: "20px",
          textTransform: "none"
        }}
      >
        + Agregar referencia
      </Button>

      {/* LEYENDA */}
      <Box
        sx={{
          backgroundColor: "#f5f7fa",
          border: "1px solid #e0e0e0",
          borderRadius: "10px",
          p: 2,
          mb: 3
        }}
      >
        <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.6 }}>
          En esta sección puedes registrar un familiar o un amigo como tu referencia. Esta persona servirá como contacto de apoyo, en caso de que sea necesario validar información o establecer comunicación contigo.
          <br /><br />
          Asegúrate de ingresar los datos correctamente para facilitar cualquier contacto futuro.
        </Typography>
      </Box>

      {/* BOTONES */}
      <Box display="flex" justifyContent="center" gap={3} mt={4}>
        <Button
          variant="outlined"
          size="large"
          onClick={back}
          sx={{
            borderRadius: "20px",
            px: 4,
            textTransform: "none",
            fontSize: "1rem"
          }}
        >
          Atrás
        </Button>

        <Button
          variant="contained"
          size="large"
          onClick={next}
          sx={{
            borderRadius: "20px",
            px: 4,
            textTransform: "none",
            fontSize: "1rem"
          }}
        >
          Siguiente
        </Button>
      </Box>
    </Box>
  );
}
